/* eslint-disable */
import React, { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import theme from '~/constants/theme';
import { useApplicationStageStatus } from '~/controllers/applicationStageStatus';
import { useGetApplication, useSelectApplicationStage, useSelectStep } from '~/controllers/wizard';
import { useDirection } from '~/hooks/i18nHooks';
import {
  ApplicationIcon,
  PaymentIcon,
  ServicesIcon,
  ContractIcon,
  CompletionIcon,
  UploadIcon,
  BackArrowIcon,
} from '~/img';
import paths from '~/pages/paths';
import { Stage } from '~/types/Application';
import { DirectionProp } from '~/types/Direction';
import { isAgent } from '~/utils/getDecodedJwt';
import ApplicationNavigation from './ApplicationNavigation';
import { WizardNavStepProps } from './WizardNavStep';
import { Button } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import colors from '~/constants/colors';
import { getStagePayload } from '~/utils/getStagePayload';
// import { setFirstLogin, setIsLetsStartedBackBtnPressed } from '~/slices/state';
import { useIsMobile, useIsTablet } from '~/hooks/useScreenSizes';
import { fallbackNavigation } from '~/controllers/fallbackNavigation';
import { handleGetutm } from '~/utils/handleGetUtm';

const WizardTopNavigation = (props: any) => {
  const { onBoarding, isServices, iconOnly } = props;
  const dir = useDirection();
  const history = useHistory();
  const applicationQuery: any = useGetApplication();
  const stageStatuses = useApplicationStageStatus();
  const stagePayload: any = getStagePayload.wizard(applicationQuery.data);
  const activeStep = stagePayload?.activeStep;
  const selectStepMutation = useSelectStep();
  const payloadData = applicationQuery?.data?.payload;
  const navSteps = fallbackNavigation?.navigation?.steps?.flatMap((item: any) => item?.steps);
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const location = useLocation();

  function getPrev(arr: any, condition: any) {
    for (let i = 1; i < arr.length; i++) {
      if (condition(arr[i], i, arr)) {
        return arr[i - 1];
      }
    }
    return undefined;
  }

  const selectStepHandler = async (activeStep: any, navSteps: any) => {
    const utmParams = handleGetutm(applicationQuery.data);

    // INITIAL INFORMATION page — back always goes to Select Products (step 1).
    // Must be first: stagePayload.type may not be 'wizard' here, making activeStep undefined.
    if (location.pathname === paths.ksa.initialInformation) {
      await selectStepMutation.mutateAsync({
        stepKey: 'services',
        stageKey: 'ksaServices',
      });
      return;
    }

    // Non-wizard stages (e.g. contract) have no wizard activeStep.
    // Fall back to the last wizard step → Business Information → Review & Confirm.
    if (!activeStep) {
      console.log('go back 33333');
      await selectStepMutation.mutateAsync({
        stepKey: 'application.reviewAndSubmit',
        stageKey: 'ksaApplication',
      });
      history.push(`${paths.ksa.application}/reviewAndConfirm?${utmParams}`);
      return;
    }
    const { key: activeStepKey } = activeStep;
    const goingTo = getPrev(navSteps, (item: any) => item?.key === activeStepKey);

    // When on Initial Information (step 2), go back to Select Products (step 1).
    if (activeStepKey === 'initialInformation') {
      console.log('go back to Select Products');
      await selectStepMutation.mutateAsync({
        stepKey: 'services',
        stageKey: 'ksaServices',
      });
      return;
    }

    // When on the first Business Information step (Business Details),
    // go back to Initial Information (step 2).
    // Call selectStep API so the backend updates activeStep, then
    // getActiveStepPath() in useSelectStep's onSuccess handles routing automatically.
    if (activeStepKey === 'application.companyInformation') {
      console.log('go back to Initial Information');
      await selectStepMutation.mutateAsync({
        stepKey: 'initialInformation',
        stageKey: 'ksaApplication',
      });
    } else {
      console.log('go back 22222');
      await selectStepMutation.mutateAsync({ stepKey: goingTo?.key, stageKey: goingTo?.stageKey });
      history.push(`${goingTo?.route}?${utmParams}`);
    }
  };


  if (stageStatuses === null) return null;

  const screensWithoutSteps = [
    paths.wizard.signContract,
    paths.wizard.payment,
    paths.wizard.completion,
    paths.stageResult.salesforceError,
    paths.ksa.services,
    ...Object.values(paths.stageResult || {}),
  ];

  const showArr = screensWithoutSteps.includes(location.pathname);

  // When iconOnly=true (used in ContentHeader beside title), always render the arrow icon
  if (iconOnly) {
    return (
      <Container className="WizardTopNavigation" dir={dir}>
        <Button
          onClick={() => {
            void selectStepHandler(activeStep, navSteps);
          }}
          className='ArrowIconbtn'
          type="text"
          icon={
            <BackArrowIcon className="navArrowIcon" style={{ transform: dir === 'rtl' ? 'scaleX(-1)' : undefined }} />
          }
        />
      </Container>
    );
  }

  return !onBoarding && !showArr && isMobile ? (
    <Container className="WizardTopNavigation" dir={dir}>
      {
        <Button
          // style={{ position: 'absolute', left: 8, top: 20 }}
          onClick={() => {
            void selectStepHandler(activeStep, navSteps);
          }}
          className='ArrowIconbtn'
          type="text"
          icon={
            <BackArrowIcon className="navArrowIcon" style={{ transform: dir === 'rtl' ? 'scaleX(-1)' : undefined }} />
          }
        />
      }
    </Container>
  ) : (
    <Button
      onClick={() => {
        void selectStepHandler(activeStep, navSteps);
      }}
      className="backBtn"
      style={{ width: '70%' }}
    >
      {t('Back')}
    </Button>
  );
};

// @ts-ignore
const Container = styled.div<DirectionProp>`
.ArrowIconbtn.ant-btn.ant-btn-text.ant-btn-icon-only{
    width: 32px !important;    
    max-width: 32px !important;
    height: 32px !important;    
    max-height: 32px !important;    

    @media (max-width: 750px) {
    width: 28px !important;    
    height: 28px !important;    
    max-width: 28px !important;
    max-height: 28px !important;  
}
}
  .navArrowIcon {
    font-size: 0px !important;
    // font-weight: 500;
    color: ${colors.grey[1200]};
  }

  .backBtn {
    border-radius: 8px;
    border: 1px solid #0069b1;
    background: #f5f9fc;
    color: #0069b1;
  }
`;

// @ts-ignore
export default WizardTopNavigation;
